import React, { createContext, useContext, useState, useEffect, useMemo } from 'react';

interface LayoutContextValue {
  ribbonContent: React.ReactNode | null;
  setRibbonContent: (content: React.ReactNode | null) => void;
}

const LayoutContext = createContext<LayoutContextValue>({
  ribbonContent: null,
  setRibbonContent: () => {},
});

export const LayoutProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [ribbonContent, setRibbonContent] = useState<React.ReactNode | null>(null);
  const value = useMemo(() => ({ ribbonContent, setRibbonContent }), [ribbonContent]);
  return <LayoutContext.Provider value={value}>{children}</LayoutContext.Provider>;
};

export function useRibbon(content: React.ReactNode) {
  const { setRibbonContent } = useContext(LayoutContext);
  useEffect(() => {
    setRibbonContent(content);
    return () => setRibbonContent(null);
  }, [content, setRibbonContent]);
}

export function useLayoutContext() {
  return useContext(LayoutContext);
}
